import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import ZakladniUdaje from "./ZakladniUdaje";
import VysledkySoutezi from "./VysledkySoutezi";

import rootPath, { RouteProps, vysledky as vysledkyPath } from "./routes-path";

interface SoutezniUdajeProps {
    senior: boolean;
    clenId: number;
}

class SoutezniUdaje extends React.PureComponent<SoutezniUdajeProps & RouteComponentProps<RouteProps>> {

    render() {

        const { match, senior, clenId } = this.props;
        const { idtClena, lang } = match.params;

        const getPath = (p: string) => (`${match.url}${p}`);


        return <Switch>
            <Route path={rootPath} exact render={() => <ZakladniUdaje idtClena={Number(idtClena)} clenId={clenId} senior={senior} />} />

            <Route path={getPath(vysledkyPath)} render={() => <VysledkySoutezi idtClena={Number(idtClena)} clenId={clenId} lang={lang} />} />

            <Redirect to={rootPath} />
        </Switch>
    }
}


export default withRouter(SoutezniUdaje); 